import { UserOutlined } from '@ant-design/icons'
import { ProviderClient } from '../../abstract/provider.client'
import { PROPERTY_APP_SESSION } from '../../abstract/provider.objects'
import { ProviderAppSessionCommon } from '../common'

export const ProviderAppSessionClient: ProviderClient = {
  key: ProviderAppSessionCommon.key,
  description: {
    icon: <UserOutlined />,
    label: 'User Session',
    triggers: [
      {
        key: 'SessionCreated',
        label: 'Session Created',
        output: [PROPERTY_APP_SESSION],
        input: [{ key: 'appSessionId' }],
      },
    ],
    actions: [
      {
        key: 'createSession',
        label: 'Create Session',
        input: [
          {
            key: 'appId',
            type: 'string',
          },
          {
            key: 'values',
            type: 'object',
          },
        ],
        output: [PROPERTY_APP_SESSION],
      },
      {
        key: 'udpateSession',
        label: 'Update Session',
        input: [
          {
            key: 'id',
            type: 'string',
          },
          {
            key: 'values',
            type: 'object',
          },
        ],
        output: [PROPERTY_APP_SESSION],
      },
    ],
  },
}
